/** @format */

import { apiCache, CACHE_DURATION } from "@/lib/cache";
import api from "../interceptor";
import { AxiosResponse } from "axios";
const storeID = process.env.NEXT_PUBLIC_STORE_ID || 1;

const url = `/products`;

export const ProductAPI = {
  getProductBySlug: async (slug: string) => {
    return await api({
      method: "GET",
      url: `${url}/${slug}`,
    });
  },

  getProductByIDS: async (ids: number[]) => {
    return await api({
      method: "GET",
      url: `${url}`,
      params: {
        currentPage: 1,
        limit: 10,
        storeID,
        ids: ids.join(","), // <-- CHUYỂN MẢNG THÀNH CHUỖI
      },
    });
  },
  getAllProducts: async ({
    limit = 9999,
    currentPage = 1,
    categorySlug,
  }: {
    limit?: number;
    currentPage?: number;
    categorySlug?: string;
  }) => {
    return await api({
      method: "GET",
      url: `${url}`,
      params: {
        currentPage: currentPage,
        limit: limit,
        storeID,
        ...(categorySlug && { categorySlug }),
      },
    });
  },
  getProductByName: async (name: string) => {
    return await api({
      method: "GET",
      url: `${url}`,
      params: {
        currentPage: 1,
        limit: 4,
        storeID,
        name: name,
      },
    });
  },

  getFeatureProducts: async ({ currentPage = 1, limit = 6 }) => {
    const cacheKey = `feature_products_cache`;
    return await apiCache.getOrFetch<AxiosResponse>(
      cacheKey,
      CACHE_DURATION.FIVE_MINUTES,
      async () => {
        return await api({
          method: "GET",
          url: `${url}`,
          params: {
            currentPage,
            limit,
            storeID,
            isFeatured: true,
          },
        });
      },
    );
  },
};
